import { render } from "./Ticket.vue?vue&type=template&id=4238ef02&scoped=true"
import script from "./Ticket.vue?vue&type=script&lang=js"
export * from "./Ticket.vue?vue&type=script&lang=js"

import "./Ticket.vue?vue&type=style&index=0&id=4238ef02&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4238ef02"]])

export default __exports__